export default {
	'ADMIN': 'Администратор',
	'MODERATOR': 'Модератор',
  };